<template>
  <section class="process-section">
    <div class="process-wrap">
      <h1 class="process-title">가입 절차</h1>

      <div class="process-grid">
        <!-- 1 -->
        <article class="process-card">
          <div class="process-icon">
            <i class="fa-solid fa-laptop-user" aria-hidden="true"></i>
          </div>
          <h3 class="process-step-title">홈페이지<br />접속 및 회원가입</h3>
        </article>

        <div class="process-arrow" aria-hidden="true">
          <i class="fa-solid fa-chevron-right"></i>
        </div>

        <!-- 2 -->
        <article class="process-card">
          <div class="process-icon">
            <i class="fa-solid fa-envelope-open-text" aria-hidden="true"></i>
          </div>
          <h3 class="process-step-title">구비서류 제출</h3>
          <p class="process-desc">（홈페이지 내 가입신청서 다운로드 후 이메일 신청 가입）</p>
        </article>

        <div class="process-arrow" aria-hidden="true">
          <i class="fa-solid fa-chevron-right"></i>
        </div>

        <!-- 3 -->
        <article class="process-card">
          <div class="process-icon">
            <i class="fa-solid fa-clipboard-check" aria-hidden="true"></i>
          </div>
          <h3 class="process-step-title">가입신청서 송부 후 안내에 따라 가입 및 결제 진행</h3>

        </article>

        <div class="process-arrow" aria-hidden="true">
          <i class="fa-solid fa-chevron-right"></i>
        </div>

        <!-- 4 -->
        <article class="process-card">
          <div class="process-icon">
            <i class="fa-solid fa-file-circle-check" aria-hidden="true"></i>
          </div>
          <h3 class="process-step-title">회원가입 완료</h3>
        </article>
      </div>
    </div>
  </section>
</template>

<script setup>
// 하드코딩 버전
</script>

<style scoped>
.process-section{
  width:100%;
  display:flex;
  justify-content:center;
}
.process-wrap{
  width:100%;
  max-width:1200px;
  padding:28px 16px 60px;
}
.process-title{
  margin:0 0 26px;
  text-align:center;
  font:800 42px/1.2 "Montserrat",system-ui;
  letter-spacing:-.5px;
  color:#0f172a;
}

/* 그리드 */
.process-grid{
  display:grid;
  grid-template-columns: 1fr 48px 1fr 48px 1fr 48px 1fr; /* 카드-화살표 반복 */
  align-items:stretch;
  gap:18px;
}

/* 카드 */
.process-card{
  background:#fff;
  border:1px solid #e8edf3;
  border-radius:14px;
  padding:28px 22px;
  text-align:center;
  box-shadow:0 6px 18px rgba(16,24,40,.05);
  display:flex;
  flex-direction:column;
  justify-content:flex-start;
}
.process-icon{
  width:68px; height:68px;
  margin:0 auto 14px;
  border-radius:16px;
  display:flex; align-items:center; justify-content:center;
  background:#eef4fb;
  color:#1d2088;
}
.process-icon i{ font-size:30px; }

/* 텍스트 */
.process-step-title{
  margin:8px 0 10px;
  font:800 18px/1.45 "Montserrat",system-ui;
  color:#0f172a;
}
.process-desc{
  margin:2px 0;
  font:600 15px/1.8 "Jost",system-ui;
  color:#334155;
}
.process-desc-weak{
  margin:2px 0 0;
  font:500 14px/1.7 "Jost",system-ui;
  color:#6b7280;
}

/* 화살표 */
.process-arrow{
  display:flex; align-items:center; justify-content:center;
  color:#9aa7b4;
}
.process-arrow i{ font-size:20px; }

/* hover */
.process-card:hover{
  border-color:#d7e3f4;
  box-shadow:0 10px 22px rgba(16,24,40,.08);
  transform:translateY(-1px);
  transition:.2s ease;
}

/* 반응형 */
@media (max-width: 1050px){
  .process-grid{
    grid-template-columns: 1fr 40px 1fr; /* 2열 */
    row-gap:22px;
  }
  /* 숨겨진 화살표는 자동 줄바꿈에서만 보이도록 */
  .process-grid > .process-arrow:nth-of-type(2),
  .process-grid > .process-arrow:nth-of-type(4){
    display:none;
  }
}
@media (max-width: 640px){
  .process-title{ font-size:34px; }
  .process-grid{
    grid-template-columns: 1fr; /* 1열 */
    gap:14px;
  }
  .process-arrow{ display:none; }
  .process-card{ padding:24px 18px; }
}
</style>
